import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

function Confirmation(props) {
  let { header, body, isOpen, handleClose, handleAction, actionButtonText, actionButtonBgColor, actionButtonColor, actionButtonHover } = props;
  actionButtonBgColor = actionButtonBgColor || '#007bff';
  actionButtonColor = actionButtonColor || 'white';
  actionButtonText = actionButtonText || 'Confirm';

  const actionButton = (
    <Button onClick={handleAction} backgroundColor={actionButtonBgColor} color={actionButtonColor} _hover={actionButtonHover} mr={3}>
      {actionButtonText}
    </Button>
  );

  return (
    <AlertDialog isOpen={isOpen} onClose={handleClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              {header}
            </AlertDialogHeader>

            <AlertDialogBody>
              {body}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={handleClose} mr={4}>
                Cancel
              </Button>
              {actionButton}
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
  );
}

Confirmation.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleAction: PropTypes.func,
  actionButtonText: PropTypes.string,
  actionButtonBgColor: PropTypes.string,
  actionButtonColor: PropTypes.string,
  actionButtonHover: PropTypes.object
};

export default Confirmation;
